var _excluded = ["direction", "align", "justify", "wrap", "templateColumns", "templateRows", "gap", "gapX", "gapY", "css"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { styled, forwardRef } from '@grupoboticario/flora-react-system';
import { filterUndefined } from '@grupoboticario/flora-react-utils';
export var StyledFlex = styled('div', {
  boxSizing: 'border-box',
  display: 'flex'
});

/**
 * @component
 * @name Flex
 * @description Flex component
 * @tutorial https://flora.gb.tech/docs/components/core/flex
 */
export var Flex = forwardRef((props, forwardedRef) => {
  var {
    direction,
    align,
    justify,
    wrap,
    templateColumns,
    templateRows,
    gap,
    gapX,
    gapY,
    css
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var flexStyles = filterUndefined({
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    flexWrap: wrap,
    gridTemplateColumns: templateColumns,
    gridTemplateRows: templateRows,
    gap,
    columnGap: gapX,
    rowGap: gapY,
    css
  });
  return /*#__PURE__*/React.createElement(StyledFlex, _extends({
    ref: forwardedRef,
    css: _extends({}, flexStyles, css)
  }, rest));
});
var StyledSpacer = styled('div', {
  flex: 1,
  justifySelf: 'stretch',
  alignSelf: 'stretch'
});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/flex
 */
export var Spacer = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledSpacer, _extends({
    ref: forwardedRef
  }, props));
});
//# sourceMappingURL=Flex.js.map